import {
  axios
} from '@/utils/request'
import md5 from 'md5'

//获取首页优惠券使用情况
export function getSellersCoupons(parameter, _data) {
  return axios({
    url: '/Seller/SellerManage/getMainCouponsInfo_Vue',
    method: 'get',
    params: parameter
  })
}

//修改密码
export function changePass(parameter, _data) {
  parameter.oldPsw = md5(parameter.oldPsw)
  parameter.newPsw = md5(parameter.newPsw)
  return axios({
    url: '/comuser/changePass_Vue',
    method: 'get',
    params: parameter
  })
}